import {Component} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import moment from 'moment';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';
import {SubscriptionTransaction} from 'src/smoothr-web-app-core/models/SubscriptionTransactions';

@Component({
	selector: 'app-alert-delete-subscription',
	templateUrl: './alert-delete-subscription.component.html',
	styleUrls: ['./alert-delete-subscription.component.scss']
})
export class AlertDeleteSubscriptionComponent {
	public subscription: SubscriptionTransaction = null;
	moment = moment;
	constructor(
		private modalCtrl: ModalController,
		private snackbarCtrl: MatSnackBar,
		private translate: TranslateService
	) {}

	static async show(modalCtrl: ModalController, subscription: SubscriptionTransaction): Promise<any> {
		const modal = await modalCtrl.create({
			component: AlertDeleteSubscriptionComponent,
			cssClass: 'short-info-modal auto-height',
			componentProps: {
				subscription: subscription
			},
			showBackdrop: true,
			backdropDismiss: true
		});
		await modal.present();
		const response = await modal.onDidDismiss();
		return response.data;
	}
	dismiss() {
		this.modalCtrl.dismiss(false);
	}
	approve() {
		this.modalCtrl.dismiss(true);
	}
}
